// src/App.js
import React from "react";
import KantPhilosophyTreeDark from "./KantTreeDark"; // ایمپورت کامپوننت جدید
import "./App.css";

function App() {
  return (
    <div
      className="App"
      style={{ width: "100%", height: "100vh", margin: 0, padding: 0 }}
    >
      <KantPhilosophyTreeDark />
    </div>
  );
}

export default App;
